import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GetSituViewRequest, GetSituViewResponse, HomeConfigFile, SituViewWebApiClient } from 'situview-webapi-client';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'situ-render-readonly',
  templateUrl: './situ-render-readonly.component.html',
  styleUrls: ['./situ-render-readonly.component.scss']
})
export class SituRenderReadonlyComponent implements OnInit, AfterViewInit {
  @Input() routeParams: any;
  
  /* view high level controls */
  paramId: string | undefined;
  images: string[] = [];

  /* view data */
  productWidth: number | undefined;
  linkToPortal: string | undefined;

  @ViewChild('modelContainer') modelContainer: ElementRef | undefined;

  constructor(
    private snackBar: MatSnackBar,
    private configService: ConfigService,
    private situView: SituViewWebApiClient) {}

  ngOnInit(): void {
    if (this.routeParams['id']) {
      this.paramId = this.routeParams['id'];
    }
  }

  ngAfterViewInit(): void {
    if (this.paramId) {
      this.getHomeById(this.paramId);
    }
  }

  openInPortal() {
    window.open(this.linkToPortal, '_blank');
  }

  private getHomeById(artifactId: string) {
    let request = new GetSituViewRequest();
    request.renderedOutputId = artifactId;

    return this.situView.getSituView(request)
      .then((response: GetSituViewResponse) => {
        if (response.success && response?.files?.length && response.files.length > 0) {
          this.linkToPortal = `${this.configService.config.situPortalBaseUrl}/situ-view?id=${this.paramId}`;
          this.images = response.files
            ?.filter((file: HomeConfigFile) => /\.(jpg|jpeg|png|webp)$/i.test(file.fileName ?? ''))
            .map((file: HomeConfigFile) => {
              return `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${response.artifactId}&filename=${file.fileName}`;
            }) ?? [];
        }
      })
      .catch((err: any) => {
        //this.showMessage("Sorry! There was an issue at our end retrieving your render. Please try again.");
      })
      .finally(() => {
        //this.loading = false;
      });
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}